export default __webpack_public_path__ + "static/media/cmcLogo.7d16a7b6.png";